var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-upload',{attrs:{"showUploadList":false,"accept":".srt,.vtt","customRequest":_vm.handleSubtitleUpload}},[(_vm.hasSubtitle)?_c('a-button',{attrs:{"type":"primary","loading":_vm.uploadLoading}},[_vm._v("更换")]):_c('a-button',{attrs:{"loading":_vm.uploadLoading}},[_c('a-icon',{attrs:{"type":"upload"}}),_vm._v(" 上传 ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }